import 'bootstrap/dist/css/bootstrap.min.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import React, {Suspense} from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import {ThroughProvider} from 'react-through';
import App from './App';
import './App.scss';
import './assets/css/main.scss';
import * as serviceWorker from './serviceWorker';

const theApp = (
    <ThroughProvider>
        <Suspense
            fallback={
                <div className='App'>
                    {/* <img src={logo} className='App-logo' alt='logo' /> */}
                    <div>loading...</div>
                </div>
            }
        >
            <App />
        </Suspense>
    </ThroughProvider>
);

ReactDOM.render(theApp, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
